<template>
  <div :style="computeStyle" class="hot-spot" @click.stop="hotSpotClick"></div>
</template>

<script>
export default {
  name: 'HotSpotComponent',
  props: {
    left: {
      type: Number,
      default: 0.16 // 8px=>.16rem
    },
    right: {
      type: Number,
      default: 0.16 // 8px=>.16rem
    },
    top: {
      type: Number,
      default: 0.16 // 8px=>.16rem
    },
    bottom: {
      type: Number,
      default: 0.16 // 8px=>.16rem
    }
  },
  data() {
    return {}
  },
  computed: {
    computeStyle() {
      return {
        left: `-${this.left}rem`,
        right: `-${this.right}rem`,
        top: `-${this.top}rem`,
        bottom: `-${this.bottom}rem`
      }
    }
  },
  methods: {
    hotSpotClick() {
      this.$emit('btnClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.hot-spot {
  position: absolute;
  z-index: 9;
}
</style>
